// House Deck artwork — production assets. Do not modify, crop, filter, or regenerate.
// Preserve original aspect ratio (1:1 square) and maximum quality.

export const HOUSES = {
  Fire: {
    name: "Fire",
    back: "/houses/fire.png",
    accent: "#C8A96E",
    descriptor: "The ember house — courage, ignition, will.",
  },
  Water: {
    name: "Water",
    back: "/houses/water.png",
    accent: "#7BC0D9",
    descriptor: "The deep well — intuition, flow, memory.",
  },
  Air: {
    name: "Air",
    back: "/houses/air.png",
    accent: "#D9CFC0",
    descriptor: "The dawn breath — clarity, connection, voice.",
  },
  Earth: {
    name: "Earth",
    back: "/houses/earth.png",
    accent: "#8FA37A",
    descriptor: "The rooted house — form, harvest, endurance.",
  },
};

export const HOUSE_ORDER = ["Fire", "Water", "Air", "Earth"];

export function houseFor(element) {
  return HOUSES[element] || HOUSES.Fire;
}
